import { LoyaltyCurrencyType, LoyaltyProgram, LoyaltyMemberPoints, LoyaltyCurrencyPointsOnly } from '@rdss/client';

/**
 * Calculates Loyalty Points from Loyalty Member factors.
 */
export const calcLoyaltyPoints = (
    value: number,
    loyaltyProgram?: LoyaltyProgram
) => {
    if (value && loyaltyProgram && Object.keys(loyaltyProgram).length > 0) {
        const loyaltyTier = loyaltyProgram.loyaltyTiers.filter(tier => tier.name === 'Basic')?.shift();

        if (loyaltyTier?.pointsMultiplyingFactor) {
            return Math.floor(value * loyaltyTier.pointsMultiplyingFactor);
        }
    }
    return 0;
};

/**
 * Get the points to earn for a specific price temporary for PDP.
 */
export const getLoyaltyPointsToEarn = (price?: number, pointEarnFactor?: number): number => {
    return price && pointEarnFactor ? Math.floor(price) * pointEarnFactor : 0
}

/**
 * Get "NonQualifying" Points.
 */
export const getNonQualifyingPoints = (
    memberPoints: LoyaltyMemberPoints
) => {
    if (memberPoints?.currencies.length > 0) {
        return memberPoints.currencies.find(
            (el: LoyaltyCurrencyPointsOnly) =>
                el.type === LoyaltyCurrencyType.nonQualifying
        )?.pointsBalance ?? 0;
    }

    return -1;
}
